// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1axsd","calendarButtons":"ClockData_calendarButtons__3bnzN"};